/* ig-collection-card.js  v7  2026-08-28
   Copies the withclarity.com tennis-bracelet card:
   [image][title][price][metal chips][LABEL][size chips][LABEL][length chips]
   Selecting any chip updates the price IN PLACE. Nothing navigates.

   No network request: every card already renders a hidden <select name=id> in
   .grid-options listing every variant as "<values / joined> - <price>" in the
   correct market currency. Parsing is by PATTERN not position, which only works
   because option values were normalised on 2026-08-27.

   IMPORTANT: chips are DISPLAYED ascending, but the chip selected on load is
   the product's own default variant - the photographed piece - not the
   smallest value. Showing a 1ct price against a 3ct photo is the exact failure
   the product standard's default-variant rule exists to prevent.

   v4: "6.0ct or above ( Contact Us )" was being silently dropped because
   RE_CARAT anchored the unit at end-of-string. Fixed; short() renders it "6+".

   v5: chips render at every width, not just mobile. Card TRIMS in the .css
   stay mobile-only.

   v6 - THREE OPTIONS, NOT TWO. The Round Four-Prong Tennis Bracelet card showed
   metal and length but no diamond size, for two separate reasons: the card only
   ever rendered ONE secondary row (length overwrote size), and that product's
   Diamond Size values were bare numbers with no unit, so they matched neither
   RE_CARAT nor RE_LENGTH and were discarded before rendering. The card now
   keeps three independent buckets - metal, size, length - and prices against
   all three.

   v7 - LABEL. Those values were renamed to 0.05ct...1.00ct on 28 Aug (Larry),
   bringing them in line with the house carat format. That made them match
   RE_CARAT, which would have relabelled the row "CARAT WEIGHT (CT)" - wrong and
   ambiguous on a tennis bracelet, where the number is the size of EACH stone,
   not the weight of the piece. sizeLabel() now keys off whether the card also
   has a length row: carat + length means a line of stones sold by the metre,
   so the row stays DIAMOND SIZE (CT).

   Collection / search templates, all widths. Revert notes in the .css. */
(function () {
  'use strict';
  var COLOUR = { 'white gold':'#E9E9E7','yellow gold':'#E4C06A','rose gold':'#E3B39F','platinum':'#D9DADE' };
  var RE_METAL   = /^(?:(14K|18K)\s+)?(White Gold|Yellow Gold|Rose Gold|Platinum)$/i;
  var RE_CARAT   = /^\d+(?:\.\d+)?(ct|tcw)\b/i;
  var RE_LENGTH  = /^\d+(?:\.\d+)?\s*CM$/i;
  var RE_BARE    = /^\d+(?:\.\d+)?$/;
  var RE_ENQUIRE = /or above|contact/i;

  function parseOption(text) {
    var t = String(text || '');
    var priceM = t.match(/\s-\s([^-]*)$/);
    var price = priceM ? priceM[1].trim() : '';
    var body = t.replace(/\s-\s[^-]*$/, '');
    var oos = /\s-\s*(Sold Out|Unavailable)\s*$/i.test(body);
    body = body.replace(/\s-\s*(Sold Out|Unavailable)\s*$/i, '').trim();
    return { values: body.split(' / ').map(function (s) { return s.trim(); }), price: price, oos: oos };
  }

  function short(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return v;
    return RE_ENQUIRE.test(v) ? String(n) + '+' : String(n);
  }

  function karatLabel(metal) {
    var m = metal.match(RE_METAL);
    if (!m) return '';
    return m[1] ? m[1].toUpperCase() : 'PT';
  }

  /* The unit lives in the label, so the label has to say which measurement it
     is. A carat row sitting next to a LENGTH row is a line of stones sold by
     length - a tennis bracelet - where the number is per stone. */
  function sizeLabel(values, hasLength) {
    for (var i = 0; i < values.length; i++) if (/tcw/i.test(values[i])) return 'TOTAL CARAT WEIGHT (TCW)';
    if (hasLength) return 'DIAMOND SIZE (CT)';
    for (var j = 0; j < values.length; j++) if (/ct/i.test(values[j])) return 'CARAT WEIGHT (CT)';
    return 'DIAMOND SIZE (CT)';
  }

  function byNumber(a, b) { return parseFloat(a) - parseFloat(b); }

  function build(card) {
    if (card.getAttribute('data-ig-cc') === '1') return;
    var select = card.querySelector('.grid-options select');
    var details = card.querySelector('.card-details__wrapper');
    if (!select || !details) return;
    card.setAttribute('data-ig-cc', '1');

    var variants = [], metals = [], sizes = [], lengths = [], seen = {};

    for (var i = 0; i < select.options.length; i++) {
      var v = parseOption(select.options[i].text);
      variants.push(v);
      for (var j = 0; j < v.values.length; j++) {
        var val = v.values[j];
        if (seen[val]) continue;
        if (RE_METAL.test(val)) { seen[val] = 1; metals.push(val); }
        else if (RE_LENGTH.test(val)) { seen[val] = 1; lengths.push(val); }
        else if (RE_CARAT.test(val) || RE_BARE.test(val)) { seen[val] = 1; sizes.push(val); }
      }
    }
    if (!variants.length) return;
    if (!metals.length && !sizes.length && !lengths.length) return;

    /* the product's own default variant, before any sorting */
    var def = { metal: null, size: null, length: null };
    variants[0].values.forEach(function (val) {
      if (!def.metal && metals.indexOf(val) > -1) def.metal = val;
      if (!def.size && sizes.indexOf(val) > -1) def.size = val;
      if (!def.length && lengths.indexOf(val) > -1) def.length = val;
    });

    sizes.sort(byNumber);
    lengths.sort(byNumber);

    var priceEl = card.querySelector('.price__regular .price_range, .price__regular .price-item, .price .price_range, .price .price-item');
    var state = {
      metal:  def.metal  || metals[0]  || null,
      size:   def.size   || sizes[0]   || null,
      length: def.length || lengths[0] || null
    };

    function hit(variant, metal, size, length) {
      var vals = variant.values;
      if (metal && vals.indexOf(metal) === -1) return false;
      if (size && vals.indexOf(size) === -1) return false;
      if (length && vals.indexOf(length) === -1) return false;
      return true;
    }
    function match(metal, size, length) {
      for (var k = 0; k < variants.length; k++) if (hit(variants[k], metal, size, length)) return variants[k];
      return null;
    }
    function inStock(metal, size, length) {
      for (var k = 0; k < variants.length; k++) {
        if (hit(variants[k], metal, size, length) && !variants[k].oos) return true;
      }
      return false;
    }

    var metalBtns = [], sizeBtns = [], lengthBtns = [];

    function refresh() {
      var v = match(state.metal, state.size, state.length);
      if (priceEl && v && v.price) priceEl.textContent = v.price;

      metalBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === state.metal));
      });
      sizeBtns.forEach(function (b) {
        var val = b.getAttribute('data-v');
        b.setAttribute('aria-pressed', String(val === state.size));
        b.classList.toggle('is-oos', !inStock(state.metal, val, state.length));
      });
      lengthBtns.forEach(function (b) {
        var val = b.getAttribute('data-v');
        b.setAttribute('aria-pressed', String(val === state.length));
        b.classList.toggle('is-oos', !inStock(state.metal, state.size, val));
      });
    }

    if (metals.length > 1) {
      var mrow = document.createElement('div');
      mrow.className = 'ig-cc-metals';
      metals.forEach(function (metal) {
        var m = metal.match(RE_METAL);
        var fam = (m && m[2] ? m[2] : '').toLowerCase();
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ig-cc-metal';
        b.setAttribute('data-v', metal);
        b.title = metal;
        b.setAttribute('aria-label', metal);
        b.style.background = COLOUR[fam] || '#DDD';
        b.textContent = karatLabel(metal);
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); state.metal = metal; refresh(); });
        metalBtns.push(b); mrow.appendChild(b);
      });
      details.appendChild(mrow);
    }

    function addRow(values, label, bucket, key) {
      if (values.length < 2) return;
      var l = document.createElement('div');
      l.className = 'ig-cc-label';
      l.textContent = label;
      details.appendChild(l);
      var row = document.createElement('div');
      row.className = 'ig-cc-secs';
      values.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ig-cc-sec';
        b.setAttribute('data-v', val);
        b.title = val;
        b.textContent = short(val);
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); state[key] = val; refresh(); });
        bucket.push(b); row.appendChild(b);
      });
      details.appendChild(row);
    }

    addRow(sizes, sizeLabel(sizes, lengths.length > 1), sizeBtns, 'size');
    addRow(lengths, 'LENGTH (CM)', lengthBtns, 'length');

    refresh();
  }

  function run() {
    var cards = document.querySelectorAll('.collection-product-item');
    for (var i = 0; i < cards.length; i++) build(cards[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var grid = document.querySelector('.collection-products, .collection__products, main');
  if (grid && window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; run(); }, 120);
    }).observe(grid, { childList: true, subtree: true });
  }
}());
